// ══════════════════════════════════════════════════════
//  extractors/unlock.js — 代币解锁日程数据提取
//
//  源：Surf tokenomics /token/tokenomics → project.tokenUnlock
//  + CoinGecko total_supply 用于换算解锁占比
// ══════════════════════════════════════════════════════

import { safeNum, safeDiv, pick } from './_shared';

export function isAvailable(project) {
  return !!project?.tokenUnlock?.ok;
}

export function extract(project /* , a */) {
  const tu = project?.tokenUnlock;
  if (!tu?.ok) return null;

  const totalSupply = safeNum(pick(project, 'cgData.market_data.total_supply'))
                   ?? safeNum(pick(project, 'cgData.market_data.circulating_supply'))
                   ?? safeNum(tu.totalSupply);

  const next30dAmount = safeNum(tu.next30dAmount);
  const next30dRatio  = safeDiv(next30dAmount, totalSupply);

  // 6 个月内累计解锁
  const next180dAmount = (tu.events || [])
    .filter(e => e?.daysFromNow >= 0 && e.daysFromNow <= 180)
    .reduce((s, e) => s + (safeNum(e.totalAmount) || 0), 0);
  const next180dRatio = safeDiv(next180dAmount, totalSupply);

  // 90 天内事件数
  const eventsNext90d = (tu.events || []).filter(e => e?.daysFromNow >= 0 && e.daysFromNow <= 90);

  // 团队/投资方占比
  const allocs = tu.allocationTotals || [];
  const teamAmt = allocs.filter(x => /team|invest|insider|advisor|founder|early/i.test(x?.name || ''))
                        .reduce((s, x) => s + (safeNum(x?.amount) || 0), 0);
  const totAmt  = allocs.reduce((s, x) => s + (safeNum(x?.amount) || 0), 0);
  const teamShare = safeDiv(teamAmt, totAmt);

  // 近期最大解锁事件
  const upcomingHigh = (tu.events || [])
    .filter(e => e?.daysFromNow >= 0 && e.daysFromNow <= 60)
    .sort((a, b) => (safeNum(b.totalAmount) || 0) - (safeNum(a.totalAmount) || 0))[0] || null;

  return {
    totalSupply,
    next30dAmount, next30dRatio,
    next180dAmount, next180dRatio,
    eventsNext90dCount: eventsNext90d.length,
    eventsNext90d,
    allocations: allocs,
    teamAmt, totalAllocAmt: totAmt, teamShare,
    upcomingHigh,
    events: tu.events || [],
    totalEvents: safeNum(tu.totalEvents) || (tu.events || []).length,
  };
}
